import { Injectable } from '@angular/core';

import { Http, QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';
import { PurchaseRegistryCollectionQuery, PurchaseRegistryCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PurchaseRegistryCollectionQuery)
@Wrapper(PurchaseRegistryCollectionQueryHandlerBase)
export class PurchaseRegistryCollectionQueryHandler {
    public constructor(
        http: Http,
        rootContext: RootContext
    ) { }
}
